import React from 'react'
import { t } from '../../../i18n'
import Modal from '../modal'

export interface ConfirmAction {
  label: string
  className: string
  onConfirm: () => void
}

interface ConfirmModalProps {
  title: string
  confirmActions: ConfirmAction[]
  onClose: () => void
  children: React.ReactNode
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  confirmActions,
  onClose,
  children
}) => (
  <Modal
    headerText={title}
    medium
    centered
    onClose={onClose}
    footerClassName="flex-nowrap"
    footerContent={
      <>
        <button
          type="button"
          className="btn btn-secondary inverted me-2"
          style={{ whiteSpace: 'nowrap' }}
          onClick={onClose}
        >
          {t('cancel')}
        </button>
        {confirmActions.map((action) => (
          <button
            key={action.label}
            type="button"
            className={action.className}
            style={{ whiteSpace: 'nowrap' }}
            onClick={action.onConfirm}
          >
            {action.label}
          </button>
        ))}
      </>
    }
  >
    {children}
  </Modal>
)

export default ConfirmModal
